var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.abTesting)?_c('div',{staticClass:"c-column",class:_vm.gridItemClass,style:({
    backgroundImage: (
      _vm.backgroundImage &&
      _vm.backgroundImage.src &&
      `url(${_vm.backgroundImage.src})`
    ),
    backgroundSize:'cover'
  })},[(_vm.title)?_c('h2',{staticClass:"t-heading-2 u-text-align-center",class:_vm.titleClass},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.subtitle)?_c('h3',{staticClass:"t-heading-2 u-text-align-center",class:_vm.subtitleClass},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.description)?_c('Wysiwyg',{class:_vm.descriptionClass,attrs:{"paragraph-size":_vm.descriptionTypography,"html":_vm.description}}):_vm._e(),_vm._v(" "),_c(_vm.type,_vm._b({tag:"component",attrs:{"get-product-function":_vm.getProductFunction}},'component',_vm.data,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }